import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FiRefreshCw } from "react-icons/fi";
import { RiInformationLine } from "react-icons/ri";
import { PiCoins } from "react-icons/pi";
import {
  showMessage,
  makeAjax,
  url,
  respStatus,
  currencyFormat,
} from "../../helpers/global_helper";
import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const Balance = (props) => {
  const [playerBalance, setPlayerBalance] = useState([]);
  const { userProfile } = useSelector((state) => ({
    userProfile: state.playerProfileR?.data ?? {},
  }));
  const [spinning, setSpinning] = useState(false);
  const [bankDetailSet, setBankDetailSet] = useState(false);

  const fetchPlayerBalance = (type) => {
    if (type == "refresh") {
      setSpinning(true);
    }

    makeAjax(url.GP_API.getBalance, [], url.GP_MS_EXT).then((response) => {
      if (type == "refresh") {
        setTimeout(() => {
          setSpinning(false);
        }, 1000);
      }
      if (response.status != respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setPlayerBalance(response.data);
    });
  };
  // Effect List
  useEffect(() => {
    fetchPlayerBalance();
  }, []);

  const [promotionCategory, setPromotionCategory] = useState([]);
  const [isClicked, setIsClicked] = useState(false);

  const getPromotionCategory = () => {
    makeAjax(url.ADMIN_API.promotionCategoryNameDD, [], url.ADMIN_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        setPromotionCategory(response.data);
      }
    );
  };

  const handleIconClick = () => {
    makeAjax(url.ADMIN_API.promotionCategoryNameDD, [], url.ADMIN_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          // showMessage(response);
          return;
        }
        setPromotionCategory(response.data);
      }
    );
    setIsClicked(!isClicked);
  };

  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Clicked outside the dropdown, so close it
      setIsClicked(false);
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Detach the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [emailVer, setEmailVer] = useState(false);
  useEffect(() => {
    const timeout = setInterval(() => {
      setEmailVer(false);
    }, 5000);
    return () => {
      clearInterval(timeout);
    };
  }, []);
  const handleEmailVer = () => {
    setEmailVer(!emailVer);
  };

  useEffect(() => {
    if (userProfile && userProfile?.player_bank_detail != null) {
      setBankDetailSet(true);
    }
  }, [userProfile]);

  return (
    <div className="user-balance">
      <div className="container">
        <div className="user-data">
          <div className="profile-data">
            <div className="user-name">
              <div className="user-icon">
                <span className="usr-profle">
                  {userProfile.username
                    ? userProfile.username[0].toUpperCase()
                    : "U"}
                </span>
              </div>
              <h3>
                <Link to="/profile">{userProfile.username}</Link>
              </h3>
            </div>
            {/* <div className="txt-history">
              <Link to="/trans-history">
                {props.t("view_transaction_history")}
              </Link>{" "}
            </div> */}
          </div>
          <div className="profile-data-inner">
            <div className="row">
              <div className="blance">
                <div className="idr-img">
                  <span className="idr-num idr">
                    {userProfile ? userProfile.currency : ""}{" "}
                    <>{currencyFormat(Math.round(playerBalance?.main_balance)) ?? 0}</>
                    <span className="refresh-icon">
                      <FiRefreshCw
                        onClick={() => {
                          fetchPlayerBalance("refresh");
                        }}
                        className={`spin-button ${spinning ? "spin" : ""}`}
                      />
                    </span>
                  </span>
                </div>
                <div className="d-flex balance-chip">
                  <div className="chip-img">
                    {" "}
                    <PiCoins className="coins" />
                  </div>
                  <div className="chip-amount px-2">
                    {currencyFormat(playerBalance?.promo_balance) ?? 0}
                  </div>
                  {/* <div className="iconhoverdiv" ref={dropdownRef}>
                      <div className="icon d-flex" onClick={handleIconClick}>
                        <RiInformationLine className="infohover-icon" />
                      </div>
                    </div> */}
                </div>
              </div>

              {/* <div className="col-5">
                <div className="deposit-btn">
                  {" "}
                  <Link to={bankDetailSet ? '/deposit' : '/bank-details/deposit'} onClick={() => setBankDetailSet(false)} className="button">
                    {props.t("deposit")}
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
          <>
            <div className="d-flex justify-content-center gap-1 mt-1">
              <Link className="balnc-trans-btn text_button-transaction_history border-transaction_history background-transaction_history" to="/trans-history">
                {props.t("transaction_history")}
              </Link>
              <Link className="balnc-trans-btn text_button-withdraw border-withdraw background-withdraw_button" to="/withdraw">
                {props.t("withdraw")}
              </Link>

              <div className="balnc-deposit-btn text_button-deposit border-deposit background-deposit_button">
                {" "}
                <Link to={bankDetailSet ? '/deposit' : '/bank-details/deposit'} onClick={() => setBankDetailSet(false)} className="button">
                  {props.t("deposit")}
                </Link>
              </div>
            </div>

          </>
        </div>
        {isClicked &&
          promotionCategory &&
          promotionCategory !== null &&
          playerBalance.promo_balance > 0 && (
            <div className="click-content">
              <p>{props.t("following_categories_are_applicable_for_promos")}</p>
              <ul>
                {promotionCategory &&
                  promotionCategory !== null &&
                  promotionCategory.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
              </ul>
            </div>
          )}
      </div>
    </div>
  );
};

Balance.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Balance);
